import { Box, Drawer, DrawerProps } from '@bcp-nextgen-dx-component-factory/design-system';
import { useHideScroll } from '@hooks';

type AppDrawerProps = DrawerProps & {
	children?: React.ReactNode;
	overlay?: {
		hide?: boolean;
		onClick?: () => void;
	};
};

export const AppDrawer = ({ children, overlay, visible, ...props }: AppDrawerProps) => {
	useHideScroll(visible);

	return (
		<>
			{visible && (
				<>
					{!overlay?.hide && (
						<Box
							onPress={overlay?.onClick}
							styles={{
								position: 'fixed',
								top: 0,
								left: 0,
								width: '100vw',
								height: '100vh',
								background: '#2E3641',
								zIndex: 2,
								opacity: 0.5,
								cursor: 'auto',
							}}
						/>
					)}
					<Drawer visible {...props}>
						{children}
					</Drawer>
				</>
			)}
		</>
	);
};
